export default __webpack_public_path__ + "static/media/studies-right.7551ef92.png";